module.exports = __webpack_public_path__ + "static/media/layout_1.b019aef1.png";